import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import Home from "@/pages/Home";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import { TerminiPage, PrivacyPage, CookiePage } from "@/pages/Legal";
import { ForgotPasswordPage, ResetPasswordPage, VerifyEmailPage } from "@/pages/AuthRecovery";
import Contattaci from "@/pages/Contattaci";
import PartnerProposal from "@/pages/PartnerProposal";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/accedi" element={<AuthPage mode="login" />} />
            <Route path="/registrati" element={<AuthPage mode="register" />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute admin><Admin /></ProtectedRoute>} />
            <Route path="/termini-e-condizioni" element={<TerminiPage />} />
            <Route path="/privacy-policy" element={<PrivacyPage />} />
            <Route path="/cookie-policy" element={<CookiePage />} />
            <Route path="/recupera-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/conferma-email" element={<VerifyEmailPage />} />
            <Route path="/contattaci" element={<Contattaci />} />
            <Route path="/diventa-partner" element={<PartnerProposal />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" richColors position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
